import { CONSENT } from '@sklik/cmp2-common';
import { getGlobalConfig } from '../config';
import { IDENTITIES_KEYS, IDENTITY_STATE, } from '../../types';
import { TIMEOUT } from '../consts';
import { createIdentityObject } from '../identities';
import { getLoginByPriority, getLoginConsentString } from './login';
import { debug } from '../debug';
/**
 * Get consent value from cookie/s
 */
const _getConsentFromCookieOrTcfApi = (cb) => {
    try {
        return CONSENT.getConsentFromCookieList(cb);
    }
    catch (_a) {
        return null;
    }
};
/**
 * Add CONSENT to identitites object (if any -> cookie / tcf)
 * If LOGIN is present (window or storage) and has euconsent -> terminate
 */
export const getConsent = (identities) => {
    var _a;
    const loginObject = getLoginByPriority((_a = identities[IDENTITIES_KEYS.login]) === null || _a === void 0 ? void 0 : _a.value);
    if (getLoginConsentString(loginObject) || ((loginObject === null || loginObject === void 0 ? void 0 : loginObject.state) && loginObject.state !== 'forget')) {
        debug({
            message: 'CONSENT (sync): Exiting CONSENT identity read because LOGIN.euconsent found',
        });
        return;
    }
    const consent = _getConsentFromCookieOrTcfApi();
    if (consent) {
        debug({
            message: 'CONSENT (sync): Storing CONSENT identity because LOGIN (window / storage) not found',
            consent,
        });
        identities[IDENTITIES_KEYS.consent] = createIdentityObject(identities[IDENTITIES_KEYS.consent], consent, IDENTITY_STATE.fresh, true);
    }
};
/**
 * Listen to events emited by CMP dialog (close / submit)
 */
export const listenToCmpDialogEvents = (updater, getter) => {
    var _a, _b;
    const handler = (consentResult) => {
        var _a, _b;
        const existsInStorage = getter(IDENTITIES_KEYS.consent);
        const consent = consentResult || _getConsentFromCookieOrTcfApi();
        if (consent || existsInStorage) {
            const value = consent || existsInStorage.value;
            const state = consent ? IDENTITY_STATE.fresh : existsInStorage.state;
            const updated = {};
            // let's try to update "consent" -> but first check if "login" not present
            const loginObject = getLoginByPriority((_a = getter(IDENTITIES_KEYS.login)) === null || _a === void 0 ? void 0 : _a.value);
            if (!getLoginConsentString(loginObject) && (!(loginObject === null || loginObject === void 0 ? void 0 : loginObject.state) || loginObject.state === 'forget')) {
                debug({
                    message: 'CONSENT (async): Storing CONSENT identity because LOGIN (window / storage) not found',
                    consent: { value, state },
                });
                updated.consent = { value, state };
            }
            // "purposeOne" not given -> wipe out ID5
            if (updated.consent && !((_b = updated.consent.value) === null || _b === void 0 ? void 0 : _b.purposeOne)) {
                updated.id5 = { value: null, state: IDENTITY_STATE.fresh };
            }
            updater(updated);
        }
    };
    let tcfApiHooked = false;
    let consentTimer = null;
    let tfcInterval = null;
    // timeout for settling -> terminated by succesfull "_getConsentFromCookieOrTcfApi" data
    consentTimer = window.setTimeout(() => {
        window.clearInterval(tfcInterval);
        handler();
    }, ((_b = (_a = getGlobalConfig()) === null || _a === void 0 ? void 0 : _a.timeouts) === null || _b === void 0 ? void 0 : _b[IDENTITIES_KEYS.consent]) || TIMEOUT);
    // when window.__tcfapi ready -> call _getConsentFromCookieOrTcfApi with callback
    const hookTFC = () => {
        if (typeof window.__tcfapi === 'function') {
            tcfApiHooked = true;
            window.clearInterval(tfcInterval);
            const sendToHandler = (consentResult) => {
                if (consentResult) {
                    window.clearTimeout(consentTimer);
                    handler(consentResult);
                }
            };
            const consentSyncCheck = _getConsentFromCookieOrTcfApi((consentResult) => {
                sendToHandler(consentResult);
            });
            sendToHandler(consentSyncCheck);
        }
    };
    // first tcf hook try
    hookTFC();
    // if TCF not already hooked -> start checking loop (terminated by "consentTimeout" or succesfull "_getConsentFromCookieOrTcfApi" data)
    if (!tcfApiHooked) {
        tfcInterval = window.setInterval(() => {
            hookTFC();
        }, 500);
    }
    // after scmp redirect (consent cookie set)
    const done = () => {
        window.clearTimeout(consentTimer);
        window.clearInterval(tfcInterval);
        handler();
    };
    window.addEventListener('scmp_redirect_done', done);
    window.addEventListener('scmp_ready', done);
    window.addEventListener('scmp_agreed', done);
    window.addEventListener('scmp_consent_set', done);
};
